import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/user/settings/notifications. The settings hub's
 * Notifications tab is now the full surface (channel matrix + marketing
 * consent + cookie choices), so this URL redirects there and old deep links
 * keep working.
 */
export const Route = createFileRoute("/_authenticated/account/user/settings/notifications")({
  beforeLoad: () => {
    throw redirect({ to: "/account/user/settings", search: { tab: "notifications" } });
  },
});
